import { useMobileLayoutContext } from '../providers/MobileLayoutContext';

export function useIsMobileLayout(): boolean {
  return useMobileLayoutContext();
}
